// import { } from 'next/router'
import { ActivityManager } from './ActivityManager';

export const activityManager = new ActivityManager();
